/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFolderOpen: {
  name: 'folder-open';
  data: string;
} = {
  name: 'folder-open',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a2 2 0 0 0-2 2v12.873a1.97 1.97 0 0 0 0 .238V19a1 1 0 0 0 1.408.913c.184.056.382.087.592.087h13.5a2 2 0 0 0 1.6-.8l4.5-6c.99-1.318.048-3.2-1.6-3.2h-1V8a2 2 0 0 0-2-2h-6.586L10 3.586A2 2 0 0 0 8.586 3H4Zm15 7V8h-6.586A2 2 0 0 1 11 7.414L8.586 5H4v9.667L6.9 10.8a2 2 0 0 1 1.6-.8H19ZM4 18l4.5-6H22l-4.5 6H4Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs></svg>`,
};
